import React, { useState } from 'react';
import { placed } from '../../../helpers/UtilityHelper';
import { Link } from 'react-router-dom';
import { Button, Chip, Grid, Typography, Box, Paper } from '@mui/material';
import ProzoDataGrid from '../../../common/ProzoDataGrid';
import { LoadingButton } from '@mui/lab';
import CheckCircleIcon from '@mui/icons-material/Download';
import { apiConstants, postGeneric } from '../../../common/constants';
import { formatDate1, formatNumber } from '../../../common/util';

const TrackingListitem = (props) => {
    const { trackingListInfo } = props;
    const listData = (trackingListInfo?.waybillDetails && trackingListInfo?.waybillDetails.length > 0) ? trackingListInfo?.waybillDetails : [];
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(100);
    const [loading, setIsLoading] = useState(false);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);

    const listDataWithInvalidAWBs = listData.map((row, index) => {
        if (row.failedReason) {
            return { ...row, id: index, failedReason: row.failedReason };
        }
        return { ...row, id: index };
    });

    const bulkCreateHandler = () => {
        setIsLoading(true)
        postGeneric(apiConstants.GET_BULK_LABELS, {
            awbList: rowSelectionModel
        }).then(({ data }) => {
            window.open(data.mergedPdf, true)
        }).catch(e => console.error(e))
            .finally(() => setIsLoading(false))
    };



    const columns = [
        // {
        //     field: "actions",
        //     headerAlign: "center",
        //     hideSortIcons: true,
        //     headerName: "Order Details",
        //     flex: 1.5,
        //     renderCell: (params) => {
        //         const { row } = params;
        //         return (
        //             <>
        //                 <Grid container rowSpacing={2}>
        //                     <Grid item xs={12}>
        //                         {row.orderId}
        //                     </Grid>
        //                     {row.shippingLabelId && row.reference !== row.shippingLabelId && (
        //                         <Grid item xs={12}>
        //                             {row.shippingLabelId}
        //                         </Grid>
        //                     )}
        //                 </Grid>
        //             </>
        //         );
        //     },
        //     valueGetter: (params) => {
        //         const { row } = params;
        //         return row.shippingLabelId 
        //     },
        // },
        {
            field: "orderId",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Order Details",
            width: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container rowSpacing={2}>
                            <Grid item xs={12}>
                                {row.orderId}
                            </Grid>
                            {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                                <Grid item xs={12}>
                                    {row.shippingLabelId}
                                </Grid>
                            )}
                            {row.failedReason && (
                                <Grid item xs={12}>
                                    {row.failedReason}
                                </Grid>
                            )}
                        </Grid>
                    </>
                );
            },
            valueGetter: (params) => {
                const { row } = params;
                return !row.failedReason ? row.shippingLabelId : row.failedReason
            },
        },
        {
            field: "reference",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Order Number",
            width: 150,
            valueGetter: (params) => params.row?.reference || '',
        },
        {
            field: "orderType",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Shipment Type",
            width: 140,
            valueGetter: (params) => params.row?.orderType || '',
        },
        {
            field: "createdDate",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Order Date",
            width: 120,
            renderCell: (params) => {
                const { row } = params;
                let orderStatusHistory = row.order_history;
                let os = orderStatusHistory?.find((item) => placed.includes(item.orderStatusEnum));
                if (os) {
                    return os.creationDate ? formatDate1(os.creationDate, 'dd MMM, yyyy') : ""
                } else {
                    return row.createdDate ? formatDate1(row.createdDate, 'dd MMM, yyyy') : ""
                }
            },
        },
        {
            field: "waybill",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "AWB Number",
            width: 120,
            renderCell: (params) => {
                const { row } = params;
                return row.waybill ? row.waybill : ""
            },
        },
        {
            field: "brandName",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Brand Name",
            width: 150,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {row?.brandName ? row?.brandName : "-"}
                            </Grid>
                        </Grid>
                    </>
                )
            },
        },
        {
            field: "courierPartner",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Courier Partner",
            width: 150,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {row.courierPartner ? row.courierPartner : ""}
                            </Grid>
                        </Grid>
                    </>
                )
            },
        },
        {
            field: "courierPartnerParent",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Courier Parent",
            width: 130,
            valueGetter: (params) => params.row?.courierPartnerParent || '',
        },
        {
            field: "courierAccountCode",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Courier Account Code",
            width: 150,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {row?.courierAccountCode ? row.courierAccountCode : ""}
                            </Grid>
                        </Grid>
                    </>
                )
            },
        },
        {
            field: "edd",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "EDD",
            width: 120,
        },
        {
            field: "eddTat",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "EDD TAT",
            width: 80,
        },
        {
            field: "zone",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Zone",
            width: 100,
        },
        {
            field: "pickupLocation",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Location",
            width: 150
        },
        {
            field: "pickupDate",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Date",
            width: 100,
            renderCell: (params) => {
                const { row } = params;
                return row?.pickupDetails ? formatDate1(row.pickupDetails?.pickupTime, 'dd MMM, yyyy') : "-"
            },
            valueGetter: (params) => {
                const { pickupDetails } = params.row;
                return formatDate1(pickupDetails?.pickupTime, 'dd MMM, yyyy');
            },
        },
        {
            field: 'pickupDetails',
            headerName: 'Pickup Details',
            width: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {row?.pickupDetails ? `Country: ${row?.pickupDetails.from_country}, State: ${row?.pickupDetails.from_state}, Pincode: ${row?.pickupDetails.from_pincode}` : "-"}
                        </Grid>
                    </Grid>
                )
            },
            valueGetter: (params) => {
                const { pickupDetails } = params.row;
                return pickupDetails ? `Country: ${pickupDetails?.from_country}, State: ${pickupDetails?.from_state},City${pickupDetails?.from_city} ,Pincode: ${pickupDetails?.from_pincode},Address:${pickupDetails?.from_address}` : "";
            },
        },
        {
            field: "pickupPincode",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Pincode",
            width: 110,
            valueGetter: (params) => params.row?.pickupDetails?.from_pincode || '',
        },
        {
            field: "pickupCity",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup City",
            width: 120,
            valueGetter: (params) => params.row?.pickupDetails?.from_city || '',
        },
        {
            field: "pickupState",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup State",
            width: 120,
            valueGetter: (params) => params.row?.pickupDetails?.from_state || '',
        },
        {
            field: "pickupName",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Name",
            width: 140,
            valueGetter: (params) => params.row?.pickupDetails?.from_name || '',
        },
        {
            field: "pickupPhone",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Phone",
            width: 130,
            valueGetter: (params) => params.row?.pickupDetails?.from_phone_number || '',
        },
        {
            field: "pickupEmail",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Email",
            width: 180,
            valueGetter: (params) => params.row?.pickupDetails?.from_email || '',
        },
        {
            field: "pickupAddress",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Pickup Address",
            width: 240,
            valueGetter: (params) => params.row?.pickupDetails?.from_address || '',
        },
        {
            field: "deliveryLocation",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Delivery Location",
            width: 150
        },
        {
            field: "dropPincode",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop Pincode",
            width: 110,
            valueGetter: (params) => params.row?.dropPincode || '',
        },
        {
            field: "dropCity",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop City",
            width: 120,
            valueGetter: (params) => params.row?.dropCity || '',
        },
        {
            field: "dropState",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop State",
            width: 120,
            valueGetter: (params) => params.row?.dropState || '',
        },
        {
            field: "dropCountry",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop Country",
            width: 110,
            valueGetter: (params) => params.row?.dropCountry || '',
        },
        {
            field: "dropName",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop Name",
            width: 150,
            valueGetter: (params) => params.row?.dropName || '',
        },
        {
            field: "dropPhone",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop Phone",
            width: 130,
            valueGetter: (params) => params.row?.dropPhone || '',
        },
        {
            field: "dropEmail",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop Email",
            width: 180,
            valueGetter: (params) => params.row?.dropEmail || '',
        },
        {
            field: "dropAddress",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Drop Address",
            width: 260,
            valueGetter: (params) => params.row?.dropAddress || '',
        },
        {
            field: "currentLocation",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Current Location",
            width: 200
        },
        {
            field: "statusDetails",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Status",
            width: 120,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {row.failedReason ? "" : (
                            <Chip variant="filled" label={row.currentStatus} />
                        )}
                    </>
                )
            },
            valueGetter: (params) => {
                const { row } = params;
                return row.failedReason ? '' : row.currentStatus;
            }
        },
        {
            field: "latestRemarks",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Latest Remarks",
            width: 150,
            valueGetter: (params) => {
                const { row } = params;
                if (row.latestRemarks) {
                    const cleanRemarks = row.latestRemarks.replace(/[^a-zA-Z0-9\s]/g, '');
                    return cleanRemarks;
                }
                return '';
            }
        },
        {
            field: "failedDeliveryRemark",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Failed Delivery Remark",
            width: 150
        },
        {
            field: "latestFailedDeliveryReason",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Latest Failed Delivery Reason",
            width: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Grid container rowSpacing={2}>
                            <Grid item xs={12}>
                                {row.latestFailedDeliveryReason}
                            </Grid>
                        </Grid>
                    </>
                );
            },

        },
        {
            field: "statusDate",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Last scan Date",
            width: 120,
            renderCell: (params) => {
                const { row } = params;
                return row?.statusDate ? formatDate1(row.statusDate, 'dd MMM, yyyy') : "-"
            },
        },

        {
            field: "deliveredDate",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Delivered Date",
            width: 120,
            valueGetter: (params) => {
                const history = params.row?.order_history;
                const delivered = [...(history ?? [])].reverse().find((item) => item?.orderStatusEnum === 'DELIVERED');
                return delivered?.creationDate ? formatDate1(delivered.creationDate, 'dd MMM, yyyy') : '';
            },
        },
        {
            field: "receivedBy",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Received By",
            width: 140,
            valueGetter: (params) => {
                const history = params.row?.order_history;
                const delivered = [...(history ?? [])].reverse().find((item) => item?.orderStatusEnum === 'DELIVERED');
                return delivered?.additional?.receiver_name || '';
            },
        },
        {
            field: "otpVerifiedDelivery",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "OTP Verified Delivery",
            width: 160,
            valueGetter: (params) => {
                if (params.row?.otpVerifiedDelivery != null) return params.row.otpVerifiedDelivery ? 'Yes' : 'No';
                const history = params.row?.order_history;
                const delivered = [...(history ?? [])].reverse().find((item) => item?.orderStatusEnum === 'DELIVERED');
                if (!delivered) return '';
                return delivered.otpVerifiedDelivery === true ? 'Yes' : 'No';
            },
        },
        {
            field: "otpVerifiedCancellation",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "OTP Verified Cancellation",
            width: 180,
            valueGetter: (params) => (params.row?.otpVerifiedCancellation != null ? (params.row.otpVerifiedCancellation ? 'Yes' : 'No') : ''),
        },
        {
            field: "deliveryOtpSent",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Delivery OTP Sent",
            width: 140,
            valueGetter: (params) => params.row?.deliveryOtpSent || '',
        },
        {
            field: "shipment",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Charged Weight ",
            width: 100,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {row.failedReason ? "" :
                            (
                                <Grid container rowSpacing={2}>
                                    <Grid item xs={12}>
                                        {formatNumber(row.item_weight)} gms
                                    </Grid>
                                </Grid>
                            )
                        }

                    </>
                );
            },
            valueGetter: (params) => {
                const { row } = params;
                // Only display item weight if there is no failed reason
                return row.failedReason ? '' : `${formatNumber(row.item_weight)} gms`;
            }
        },
        {
            field: "deadWeight",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Dead Weight",
            width: 100,
            valueGetter: (params) => (params.row?.deadWeight != null ? `${formatNumber(params.row.deadWeight)} gms` : ''),
        },
        {
            field: "shipmentDimensions",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Dimensions (L×B×H)",
            width: 150,
            valueGetter: (params) => {
                const { length, breadth, height } = params.row || {};
                return (length != null && breadth != null && height != null) ? `${length} × ${breadth} × ${height}` : '';
            },
        },
        {
            field: "paymentDetails",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Payment Details",
            width: 130,
            renderCell: (params) => {
                const { row } = params;
                const paymentMode = row.paymentMode ? row.paymentMode : "";
                const color = paymentMode === "COD" ? "error" : "success";
                return (
                    <>
                        {row.failedReason ? "" :
                            (<Grid container rowSpacing={2} sx={{ mb: 1 }}>
                                <Grid item xs={12} sx={{ mb: -1 }}>
                                    {row.invoiceValue ? "Rs. " + formatNumber(row.invoiceValue) : ""}
                                </Grid>
                                <Grid item xs={12}>
                                    <Chip size="small" color={color} label={paymentMode} />
                                </Grid>
                            </Grid>)
                        }
                    </>
                );
            },
            valueGetter: (params) => {
                const { row } = params;
                if (row.failedReason) return '';
                const invoiceValue = row.invoiceValue ? `Rs. ${row.invoiceValue} ${row.paymentMode}` : '';
                return invoiceValue;
            }
        },
        {
            field: "current_ndr",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Last NDR Remark",
            width: 200,
            renderCell: (params) => {
                const { row } = params;
                let statusDetails = row.order_history;
                const lastFailedDelivery = [...(statusDetails ?? [])].reverse().find(item => item?.orderStatusCode === 9);
                if (lastFailedDelivery) {
                    return lastFailedDelivery?.remark
                }
                return ''
            },
            valueGetter: (params) => {
                const { row } = params;
                let statusDetails = row.order_history;
                const lastFailedDelivery = [...(statusDetails ?? [])].reverse().find(item => item?.orderStatusCode === 9);
                return lastFailedDelivery?.remark || '';
            }
        },
        {
            field: "attemptCount",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Attempt Count",
            width: 150,
            renderCell: (params) => {
                const { row } = params;
                const attemptCount = row.order_history?.reduce((acc, item) => acc + (item?.orderStatusEnum === "OUT_FOR_DELIVERY" ? 1 : 0), 0) || 0;
                return attemptCount;
            },
            valueGetter: (params) => {
                const { row } = params;
                return row.order_history?.reduce((acc, item) => acc + (item?.orderStatusEnum === "OUT_FOR_DELIVERY" ? 1 : 0), 0) || 0;
            }
        },
        {
            field: "rtoAwb", headerAlign: "center", hideSortIcons: true, headerName: "RTO AWB", width: 130,
            valueGetter: (params) => params.row?.rtoAwb || '',
        },
        {
            field: "channelName", headerAlign: "center", hideSortIcons: true, headerName: "Channel Name", width: 140,
            valueGetter: (params) => params.row?.channelName || '',
        },
        {
            field: "items", headerAlign: "center", hideSortIcons: true, headerName: "Items", width: 180,
            valueGetter: (params) => params.row?.items || '',
        },
        {
            field: "itemDescription", headerAlign: "center", hideSortIcons: true, headerName: "Item Description", width: 200,
            valueGetter: (params) => params.row?.itemDescription || '',
        },
        {
            field: "itemsQuantity", headerAlign: "center", hideSortIcons: true, headerName: "Items Quantity", width: 160,
            valueGetter: (params) => params.row?.itemsQuantity || '',
        },
        {
            field: "productSkuCode", headerAlign: "center", hideSortIcons: true, headerName: "Product SKU Code", width: 180,
            valueGetter: (params) => params.row?.productSkuCode || '',
        },
        {
            field: "invoiceNumber", headerAlign: "center", hideSortIcons: true, headerName: "Invoice Number", width: 150,
            valueGetter: (params) => params.row?.invoiceNumber || '',
        },
        {
            field: "invoiceDate", headerAlign: "center", hideSortIcons: true, headerName: "Invoice Date", width: 150,
            valueGetter: (params) => params.row?.invoiceDate || '',
        },
        {
            field: "codValue", headerAlign: "center", hideSortIcons: true, headerName: "COD Value", width: 110,
            valueGetter: (params) => (params.row?.codValue != null ? params.row.codValue : ''),
        },
        {
            field: "isPartialPrepaid", headerAlign: "center", hideSortIcons: true, headerName: "Partial Prepaid", width: 120,
            valueGetter: (params) => (params.row?.isPartialPrepaid != null ? (params.row.isPartialPrepaid ? 'Yes' : 'No') : ''),
        },
        {
            field: "merchantPrice", headerAlign: "center", hideSortIcons: true, headerName: "Merchant Price", width: 130,
            valueGetter: (params) => params.row?.merchantPrice || '',
        },
        {
            field: "merchantPriceRto", headerAlign: "center", hideSortIcons: true, headerName: "Merchant Price (RTO)", width: 150,
            valueGetter: (params) => params.row?.merchantPriceRto || '',
        },
        {
            field: "minTat", headerAlign: "center", hideSortIcons: true, headerName: "Min TAT", width: 90,
            valueGetter: (params) => (params.row?.minTat != null ? params.row.minTat : ''),
        },
        {
            field: "pickupGst", headerAlign: "center", hideSortIcons: true, headerName: "Pickup GST", width: 150,
            valueGetter: (params) => params.row?.pickupGst || '',
        },
        {
            field: "pickupCountry", headerAlign: "center", hideSortIcons: true, headerName: "Pickup Country", width: 120,
            valueGetter: (params) => params.row?.pickupCountry || '',
        },
        {
            field: "rvpQcEnabled", headerAlign: "center", hideSortIcons: true, headerName: "RVP QC Enabled", width: 140,
            valueGetter: (params) => params.row?.rvpQcEnabled || '',
        },
        {
            field: "ndrStatus", headerAlign: "center", hideSortIcons: true, headerName: "NDR Status", width: 130,
            valueGetter: (params) => params.row?.ndrStatus || '',
        },
        {
            field: "rtoMarkDate", headerAlign: "center", hideSortIcons: true, headerName: "RTO Mark Date", width: 160,
            valueGetter: (params) => params.row?.rtoMarkDate || '',
        },
        {
            field: "rtoDeliveryDate", headerAlign: "center", hideSortIcons: true, headerName: "RTO Delivery Date", width: 160,
            valueGetter: (params) => params.row?.rtoDeliveryDate || '',
        },
        {
            field: "failedDeliveryTimestamp", headerAlign: "center", hideSortIcons: true, headerName: "Failed Delivery Timestamp", width: 190,
            valueGetter: (params) => params.row?.failedDeliveryTimestamp || '',
        },
        {
            // Last data column (Action is not exported). Filled by the file-upload tracking API; blank for
            // AWBs that were not found.
            field: "insuranceFlag", headerAlign: "center", hideSortIcons: true, headerName: "Insurance Flag", width: 130,
            valueGetter: (params) => params.row?.insuranceFlag || '',
        },
        {
            field: "action",
            headerAlign: "center",
            hideSortIcons: true,
            disableExport: true,
            headerName: "Action",
            width: 100,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Grid container rowSpacing={1}>
                        <Grid item xs={6}>
                            {row.failedReason ? (
                                ""
                            ) :
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="warning"
                                    component={Link}
                                    // to={`/order-detail?waybill=${row.waybill}`}
                                    to={`/order-detail/${row.waybill}`}
                                >
                                    Details
                                </Button>
                            }

                        </Grid>
                    </Grid>
                );
            },
        },
    ];


    const totalCount = listData.length;
    const failedCount = listData.filter(r => r.failedReason).length;
    const successCount = totalCount - failedCount;

    return (
        <Paper elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0', overflow: 'hidden' }}>
            {totalCount > 0 && (
                <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fafafa' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            Tracking Results
                        </Typography>
                        <Chip label={`${successCount} found`} size="small" color="success" variant="outlined" />
                        {failedCount > 0 && (
                            <Chip label={`${failedCount} not found`} size="small" color="error" variant="outlined" />
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {rowSelectionModel.length > 0 && (
                            <LoadingButton
                                loading={loading}
                                onClick={bulkCreateHandler}
                                variant='contained'
                                size="small"
                                startIcon={<CheckCircleIcon />}
                                sx={{ borderRadius: '8px', textTransform: 'none' }}
                            >
                                Download Labels ({rowSelectionModel.length})
                            </LoadingButton>
                        )}
                    </Box>
                </Box>
            )}
            <ProzoDataGrid
                columns={columns}
                autoHeight={true}
                rows={listDataWithInvalidAWBs || []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                exportToExcel={true}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                checkboxSelection={true}
                isRowSelectable={(params) => !params.row?.failedReason}
                rowSelectionModel={rowSelectionModel}
                setRowSelectionModel={setRowSelectionModel}
                paginationMode={'client'}
                rowHeight={120}
                rowCount={listData?.length || 0}
                getRowId={(row) => row.id ?? row.waybill}
                sx={{
                    '& .MuiDataGrid-row': {
                        '&:hover': { backgroundColor: '#f5f8ff' },
                    },
                    '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid #f0f0f0',
                        fontSize: '13px',
                    },
                }}
            />
        </Paper>
    );
};
export default TrackingListitem;